import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Reference} from '@association/_common/models/reference.models';

export const LoadList = createAction(
    '[References] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[References] Load List Success',
    props<{ payload: { items: Reference[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[References] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetLoading = createAction(
    '[References] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[References] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[References] Update Item Success',
    props<{ payload: Reference }>()
);

export const DeleteItem = createAction(
    '[References] Delete Item',
    props<{ payload: Reference }>()
);

export const DeleteItemSuccess = createAction(
    '[References] Delete Item Success',
    props<{ payload: Reference }>()
);

export const DeleteItemFailure = createAction(
    '[References] Delete Item Failure',
    props<{ payload: Reference }>()
);

export const SetInitialState = createAction(
    '[References] Set Initial State'
);
